import React from 'react';
import PropTypes from 'prop-types';
import { getPublicUrl } from 'helpers/resourcePath';


const NewSpinner = ({ loading }) => (
  (loading) ? (
    <div className="NewSpinner">
      <div className="NewSpinner__spinner">
        <img src={`${getPublicUrl()}/images/loader.svg`} alt="spinner" />
      </div>
    </div>) :
    null
);

NewSpinner.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default NewSpinner;
